export default {
      user: state => {
        return state.user
      },
      auth: state => {
        return state.auth
      },
      menu: state => {
        return state.menu
      },
      isQuadro: state => {
          console.log(state.user);

          return state.user
              &&_.toNumber(state.user.dados_perfil.fk_id_tipo_de_usuario) == 3
              && _.toNumber(state.user.pk_id_quadro) > 0
              && _.indexOf([15,16,47], _.toNumber(localStorage.getItem('grupoUsuario'))) > -1
      },
      isFiliadoMilitante: state => {
          return state.user
              && _.toNumber(state.user.dados_perfil.fk_id_tipo_de_usuario) == 2
              && _.indexOf([15], localStorage.getItem('grupoUsuario')) > -1
      },
      isPessoaFisica: state => {
          return state.user
              && _.toNumber(state.user.dados_perfil.fk_id_tipo_de_usuario) == 4
      },

}


// WEBPACK FOOTER //
// ./src/vuex/getters.js